import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BookingApprovalsHistoryModel } from '../../content/recourse-booking/model/booking-approvals-history-model';
import { completeEndpoint, EndpointPart } from '../../core/global';
import { EndpointService } from '../endpoint/endpoint.service';

/**
 * @deprecated Use BookingApprovalsControllerService instead
 */
@Injectable({
  providedIn: 'root',
})
export class BookingApprovalsHistoryService {
  private readonly http = inject(HttpClient);
  private readonly endpointService = inject(EndpointService);

  public getBookingApprovalsHistory(recourseBookingId: number): Observable<BookingApprovalsHistoryModel[]> {
    const pathParams: Map<string, number> = new Map();
    pathParams.set('recourseBookingId', recourseBookingId);

    const url: string = this.endpointService.getEndpointUrl(
      completeEndpoint(EndpointPart.GET_BOOKING_APPROVALS_HISTORY),
      pathParams,
    );
    return this.http.get<BookingApprovalsHistoryModel[]>(url);
  }
}
